import styles from './HelpOrphanHome.module.css'
import logo from './image/imgHelpOrphanHome.png'
export const HelpOrphanHome = () =>{
    return(
        <div className={styles.help_orphan_home_container}>
            <div className={styles.help_orphan_home_title}>
                <span className={styles.help_orphan_home_h1}>Благотворительный проект коллег из Байкальского банка Сбера</span>
                <span className={styles.help_orphan_home_h2}>«Мама, пойдем домой»</span>
                <span className={styles.help_orphan_home_h1}>по созданию фото и видео анкет детей из детских домов</span>
            </div>
            <img src={logo} className={styles.help_orphan_home_logo}/>
            <div>
                <span className={styles.help_orphan_home_body}>Благодаря проекту уже </span>
                <span className={styles.help_orphan_home_h2}>19 детей </span>
                <span className={styles.help_orphan_home_body}>обрели тепло семейного очага</span>
            </div>
        </div>
    )
}